import Vue from "vue";
import Router from "vue-router";
import BaseView from "@/views/BaseView";
import About from "@/views/About";
import Connect from "@/views/Connect";
import menuRoutes from "./menuRoutes";
Vue.use(Router);

export default new Router({
	// mode: "history",
	routes: [
		...menuRoutes,
		{
			path: "/",
			name: "BaseView",
			component: BaseView
		},
		{
			path: "/about",
			name: "About",
			component: About
		},
		{
			path: "/connect",
			name: "Connect",
			component: Connect
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js